import React, { useState } from 'react'
import { useTranslation } from 'gatsby-plugin-react-i18next'
import { Fade } from 'react-awesome-reveal'

const ContactSection = () => {
  const initialForm = { name: '', email: '', subject: '', message: '', 'bot-field': null }

  const { t } = useTranslation()

  const [form, setForm] = useState(initialForm)
  const [submited, isSubmited] = useState(false)

  const encode = (data) => {
    return Object.keys(data)
      .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(data[key]))
      .join('&')
  }

  const activeEnv =
  process.env.GATSBY_ACTIVE_ENV || process.env.NODE_ENV || 'development'

  const submit = (event) => {
    if (activeEnv !== 'development') {
      if (form['bot-field'] === null) {
        delete form['bot-field']
      }
      const f = event.target
      fetch('/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: encode({
          'form-name': f.getAttribute('name'),
          ...form
        })
      }).then(() => {
        isSubmited(true)
        setForm(initialForm)
      }).catch(error => alert(error))
    } else {
      isSubmited(true)
    }
    event.preventDefault()
  }

  const handleInput = (event) => {
    const { name, value } = event.target

    setForm({
      ...form, [name]: value
    })
  }

  return (
    <section
      id="section7"
      className="relative bg-gray-100 w-full"
    >
      <div className="w-5/6 md:w-3/4 lg:w-4/6 mx-auto py-16">
        <Fade direction="up">
        <h2 className="title font-bold text-4xl text-martinique relative z-10">
          {t('contactSection.title')}
        </h2>
        </Fade>

        <div className="flex pt-12 flex-col md:flex-row w-full md:mx-auto md:pt-24 justify-between items-start content-start">
          <div className="bg-map absolute md:relative z-10">
            <h3 className="font-bold text-xl text-martinique">{t('contactSection.subtitle')}</h3>
            <span className="text-martinique mt-10">{t('contactSection.sendemail')} <a href="mailto:contact@alexandrelion.com" className="text-radical-red-500">email</a>. 👋</span>
          </div>
          <form className="flex flex-col w-full md:w-2/3 mt-20 md:mt-0 z-20" name="contact" onSubmit={submit} data-netlify="true"
                data-netlify-honeypot="bot-field">
            <input type="hidden" name="form-name" value="contact" />
            <div hidden>
              <label>
                Don’t fill this out:
                <input name="bot-field" onChange={handleInput} />
              </label>
              </div>
            <div className="flex flex-col md:flex-row mb-5">
              <input value={form.name} onChange={handleInput} type="text" name="name" required="required" className="mr-5 px-5 w-full py-4 text-gray-500 rounded-full shadow-lg outline-none" placeholder={t('contactSection.form.name')}></input>
              <input value={form.email} onChange={handleInput} type="email" name="email" required="required" className="px-5 py-4 mt-5 md:mt-0 text-gray-500 rounded-full shadow-lg outline-none" placeholder={t('contactSection.form.email')}></input>
            </div>
            <input value={form.subject} onChange={handleInput} type="text" name="subject" required="required" className="mb-5 px-5 py-4 text-gray-500 rounded-full shadow-lg outline-none" placeholder={t('contactSection.form.subject')}></input>
            <textarea value={form.message} onChange={handleInput} name="message" required="required" className="px-5 py-4 rounded-3xl shadow-lg outline-none text-gray-500" placeholder="Message" rows="5"></textarea>
            {!submited
              ? <button type="submit" className="inline-block bg-radical-red px-6 py-3 mt-5 font-bold text-white rounded-full transition duration-500 ease-in-out hover:bg-radical-red-400 transform hover:scale-110 relative z-10">
              {t('contactSection.contactme')}
            </button>
              : <div className="inline-block bg-green-500 text-center px-6 py-3 mt-5 font-bold text-white rounded-full relative z-10">
              {t('contactSection.sent')} 🎉
            </div>}
          </form>

        </div>
      </div>
    </section>
  )
}

export default ContactSection
